import type { OnboardingEvent } from "./events";

const RING_CAPACITY = 200;

const ring: OnboardingEvent[] = [];

export function pushEvent(event: OnboardingEvent): void {
  ring.push(event);
  if (ring.length > RING_CAPACITY) {
    ring.splice(0, ring.length - RING_CAPACITY);
  }
  exposeForDevtools();
}

export function snapshotEvents(): OnboardingEvent[] {
  return ring.slice();
}

export function clearEvents(): void {
  ring.length = 0;
  exposeForDevtools();
}

let exposed = false;

function exposeForDevtools(): void {
  if (exposed) return;
  if (typeof window === "undefined") return;
  // Dev-only inspection handle. Safe in prod too — it only exposes
  // already-in-memory client-side events for this user/session.
  (window as unknown as Record<string, unknown>).__staylayerOnboardingEvents = {
    snapshot: snapshotEvents,
    clear: clearEvents,
  };
  exposed = true;
}
